import { useEffect, useRef, useState } from 'react';

export default function useChartContainerReady() {
  const containerRef = useRef(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const node = containerRef.current;
    if (!node) return undefined;

    const updateReady = () => {
      const { width, height } = node.getBoundingClientRect();
      setIsReady(width > 0 && height > 0);
    };

    updateReady();

    if (typeof ResizeObserver === 'function') {
      const observer = new ResizeObserver(() => updateReady());
      observer.observe(node);
      return () => observer.disconnect();
    }

    const rafId = window.requestAnimationFrame(updateReady);
    return () => window.cancelAnimationFrame(rafId);
  }, []);

  return { containerRef, isReady };
}
